import { useContext } from 'react';
import {
  DrugSearchConfigContext,
  IDrugSearchConfigContext,
} from '../../providers/drug-search-config/drug-search-config.context';

export const useDrugSearchConfigContext = (): IDrugSearchConfigContext =>
  useContext<IDrugSearchConfigContext>(DrugSearchConfigContext);
